var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page home-page"},[_c('HomeHero',{attrs:{"image":_vm.IMAGES.hero}}),_c('HomeWhoWeAre'),_c('HomePainPoints'),_c('HomeEcosystems'),_c('HomePersonas'),_c('HomeValueProposition'),_c('HomeJoin'),_c('HomeCTA',{attrs:{"image":_vm.IMAGES.partner}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }